import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductProtectionPlans from 'data-hooks/useProductProtectionPlans';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPAddProtectionPlanEvent from 'data-hooks/useEvents/usePDPAddProtectionPlanEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePDPPrice from 'data-hooks/usePDPPrice';
import PDPProtectionPlanSelectorUI from './PDPProtectionPlanSelectorUI';
import useSetPdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/useSetPdpSelectedProtectionPlanId';
import usePDPOptions from '../state/context/usePDPOptions';
import PDPProtectionPlanSelectorPlaceholder from './PDPProtectionPlanSelectorPlaceholder';
function getPrice(percentage, priceData) {
  if (priceData.price?.original_price) {
    return Math.round((priceData.optionPrice + priceData.price.original_price) * percentage / 100);
  }
  return null;
}
const PDPProtectionPlanSelectorInner = () => {
  const $ = _c(10);
  const {
    loading
  } = usePDPBasicDetails();
  const {
    loading: protectionPlanLoading,
    data: protectionPlansData
  } = useProductProtectionPlans();
  const {
    data: t0
  } = usePDPOptions();
  const {
    allProtectionPlanTypes
  } = t0;
  const setSelectedProtectionPlanId = useSetPdpSelectedProtectionPlanId();
  const {
    data: priceData
  } = usePDPPrice();
  const {
    addProtectionPlanEvent
  } = usePDPAddProtectionPlanEvent();
  let t1;
  if ($[0] !== allProtectionPlanTypes || $[1] !== priceData) {
    t1 = allProtectionPlanTypes ? allProtectionPlanTypes.map(plan => ({
      ...plan,
      plan_price: getPrice(plan?.plan_percent || 0, priceData || {})
    })) : [];
    $[0] = allProtectionPlanTypes;
    $[1] = priceData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const allPlans = t1;
  let t2;
  if ($[3] !== addProtectionPlanEvent || $[4] !== allPlans || $[5] !== loading || $[6] !== protectionPlanLoading || $[7] !== protectionPlansData?.meta || $[8] !== setSelectedProtectionPlanId) {
    t2 = protectionPlansData?.meta?.eligible_protection_planids?.length > 0 ? <PDPProtectionPlanSelectorUI allProtectionPlanTypes={allPlans} loading={loading && protectionPlanLoading} meta={protectionPlansData?.meta} onProtectionPlanSelection={planId => {
      setSelectedProtectionPlanId(planId);
      const selectedPlan = allPlans.find(p => p.plan_id === planId);
      if (selectedPlan) {
        addProtectionPlanEvent(selectedPlan);
      }
    }} /> : null;
    $[3] = addProtectionPlanEvent;
    $[4] = allPlans;
    $[5] = loading;
    $[6] = protectionPlanLoading;
    $[7] = protectionPlansData?.meta;
    $[8] = setSelectedProtectionPlanId;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
const PDPProtectionPlanSelector = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPProtectionPlanSelectorPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPProtectionPlanSelectorInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPProtectionPlanSelector;